// core/stores/threadDraftStore.ts — 1.24.00 C2: carries the post a user just
// chose "Add to thread" on across a navigation, so the Composer can pick it up
// and show the "Continuing your thread" chip.
//
// Deliberately the same one-shot handoff shape as quoteDraftStore: the pending
// root is cleared the instant a composer renders it, so it can never linger and
// re-attach itself to an unrelated post the next time a composer mounts.

import { create } from 'zustand';
import type { Post } from '@/core/models/post';

interface ThreadDraftState {
  pendingThreadRoot: Post | null;
  setPendingThreadRoot: (post: Post) => void;
  clearPendingThreadRoot: () => void;
}

export const useThreadDraftStore = create<ThreadDraftState>((set) => ({
  pendingThreadRoot: null,
  setPendingThreadRoot: (post) => set({ pendingThreadRoot: post }),
  clearPendingThreadRoot: () => set({ pendingThreadRoot: null }),
}));

/**
 * Everything "Add to thread" needs from its host, so the two call sites (the
 * ··· menu on any card, and the button under the post on its detail page) share
 * one behaviour instead of two copies that drift.
 */
export interface ThreadHandoff {
  openComposeSheet: () => void;
}

/**
 * Stage `post` as the thread root and put a composer in front of the user.
 *
 * The shared shell opens the overlay on every viewport without leaving the post.
 */
export function startThreadPart(post: Post, handoff: ThreadHandoff): void {
  useThreadDraftStore.getState().setPendingThreadRoot(post);
  handoff.openComposeSheet();
}
